import React from "react";
import { ListItem, ListItemText } from "@mui/material";

/**
 * A list item component for displaying an entry in the entries list
 * @param {Object} props
 * @param {Object} props.entry - The entry summary object
 * @param {boolean} props.selected - Whether this entry is currently selected
 * @param {Function} props.onClick - Click handler for selecting this entry
 */
export default function EntryListItem({ entry, selected, onClick }) {
  return (
    <ListItem button="true" onClick={onClick} selected={selected}>
      <ListItemText
        primary={`#${entry.sequenceNumber || entry.id} - ${
          entry.horseName || "Unknown Horse"
        }`}
        secondary={`${entry.riderFirstName || ""} ${entry.riderLastName || ""}`}
      />
    </ListItem>
  );
}
